A human-readable message describing the issue with the field value.

For example, "Value could not be used to infer a valid SEEK location".
